/**
 * Single source of truth for access-control module names and parent/child grouping.
 * When adding a new menu feature, add its module_name here — Access Control will
 * sync it to the backend via POST /bp/access-modules/sync/.
 */
import moduleGroups from '@/components/third-party/modules.json';

export const MODULE_GROUPS = moduleGroups;

const DEFAULT_ACCESS_FLAGS = {
  create_access: false,
  read_access: false,
  update_access: false,
  delete_access: false,
};

/** Flat, de-duplicated list of every module_name (parents + children). */
export const flattenModuleNames = (groups = MODULE_GROUPS) => {
  const names = new Set();
  Object.entries(groups).forEach(([parent, children]) => {
    names.add(parent);
    if (Array.isArray(children)) {
      children.forEach((child) => names.add(child));
    }
  });
  return Array.from(names);
};

export const findParentGroupName = (moduleName, groups = MODULE_GROUPS) => {
  if (groups[moduleName]) return moduleName;
  return Object.keys(groups).find(
    (key) => Array.isArray(groups[key]) && groups[key].includes(moduleName)
  );
};

export const getChildModuleNames = (parentName, groups = MODULE_GROUPS) =>
  groups[parentName] || [];

/** Payload for POST /bp/access-modules/sync/ */
export const buildAccessModuleSyncPayload = (groups = MODULE_GROUPS) => ({
  modules: flattenModuleNames(groups).map((module_name) => ({ module_name })),
  roles_scope: { type: 'ALL_ACTIVE_ROLES' },
  default_access: { ...DEFAULT_ACCESS_FLAGS },
});
